import { EMPTY_AUDIT_LOG_MODEL } from "presentation/model/AuditLog/AuditLogMaintenanceModel";
import { useState } from "react";
import { createContainer } from "react-tracked";

const {
    Provider: AuditLogMaintenanceProvider,
    useTracked: useAuditLogMaintenanceTracked
} = createContainer(() => useState(EMPTY_AUDIT_LOG_MODEL), { concurrentMode: true });
export { AuditLogMaintenanceProvider, useAuditLogMaintenanceTracked };

